import { IPaginationResponse } from '../../../common';
import { IPaymentRequestResponse } from '../dtos';

const paymentRequestsResponse: IPaginationResponse<IPaymentRequestResponse> = {
  items: [
    {
      id: 'ea8ad59a-b779-4157-a230-1aa8f6404c7c',
      paymentId: 'ea8ad59a-b779-4157-a230-1aa8f6404c7c',
      paymentConfigurationId: 'ea8ad59a-b779-4157-a230-1aa8f6404c7c',
      paymentProviderType: 'hyperpay',
      paymentRequestId: 'ea8ad59a-b779-4157-a230-1aa8f6404c7c',
      paymentUrl: 'url',
      integrity: 'integrity url',
      modifiedOnUtc: '2025-02-18T20:11:49.4609172',
      createdById: 'bcbe94e8-e31a-4c1d-bc88-f26c6bfca3ab',
      modifiedById: 'bcbe94e8-e31a-4c1d-bc88-f26c6bfca3ab',
      createdOnUtc: '2025-02-18T20:11:49.4609054'
    },
    {
      id: 'ea8ad59a-b779-4157-a230-1aa8f6404c7c',
      paymentId: 'ea8ad59a-b779-4157-a230-1aa8f6404c7c',
      paymentConfigurationId: 'ea8ad59a-b779-4157-a230-1aa8f6404c7c',
      paymentProviderType: 'hyperpay',
      paymentRequestId: 'ea8ad59a-b779-4157-a230-1aa8f6404c7c',
      paymentUrl: 'url',
      integrity: 'integrity url',
      modifiedOnUtc: '2025-02-18T20:11:49.4609172',
      createdById: 'bcbe94e8-e31a-4c1d-bc88-f26c6bfca3ab',
      modifiedById: 'bcbe94e8-e31a-4c1d-bc88-f26c6bfca3ab',
      createdOnUtc: '2025-02-18T20:11:49.4609054'
    },
    {
      id: 'ea8ad59a-b779-4157-a230-1aa8f6404c7c',
      paymentId: 'ea8ad59a-b779-4157-a230-1aa8f6404c7c',
      paymentConfigurationId: 'ea8ad59a-b779-4157-a230-1aa8f6404c7c',
      paymentProviderType: 'hyperpay',
      paymentRequestId: 'ea8ad59a-b779-4157-a230-1aa8f6404c7c',
      paymentUrl: 'url',
      integrity: 'integrity url',
      modifiedOnUtc: '2025-02-18T20:11:49.4609172',
      createdById: 'bcbe94e8-e31a-4c1d-bc88-f26c6bfca3ab',
      modifiedById: 'bcbe94e8-e31a-4c1d-bc88-f26c6bfca3ab',
      createdOnUtc: '2025-02-18T20:11:49.4609054'
    },
    {
      id: 'ea8ad59a-b779-4157-a230-1aa8f6404c7c',
      paymentId: 'ea8ad59a-b779-4157-a230-1aa8f6404c7c',
      paymentConfigurationId: 'ea8ad59a-b779-4157-a230-1aa8f6404c7c',
      paymentProviderType: 'hyperpay',
      paymentRequestId: 'ea8ad59a-b779-4157-a230-1aa8f6404c7c',
      paymentUrl: 'url',
      integrity: 'integrity url',
      modifiedOnUtc: '2025-02-18T20:11:49.4609172',
      createdById: 'bcbe94e8-e31a-4c1d-bc88-f26c6bfca3ab',
      modifiedById: 'bcbe94e8-e31a-4c1d-bc88-f26c6bfca3ab',
      createdOnUtc: '2025-02-18T20:11:49.4609054'
    }
  ],
  paginationMetadata: {
    totalItemCount: 4,
    numberOfPages: 1,
    pageSize: 10,
    order: 'Ascending',
    page: 1,
    hasNext: false,
    hasPrevious: false
  }
};

const paymentRequestResponse: IPaymentRequestResponse = {
  id: 'ea8ad59a-b779-4157-a230-1aa8f6404c7c',
  paymentId: 'ea8ad59a-b779-4157-a230-1aa8f6404c7c',
  paymentConfigurationId: 'ea8ad59a-b779-4157-a230-1aa8f6404c7c',
  paymentProviderType: 'hyperpay',
  paymentRequestId: 'ea8ad59a-b779-4157-a230-1aa8f6404c7c',
  paymentUrl: 'url',
  integrity: 'integrity url',
  modifiedOnUtc: '2025-02-18T20:11:49.4609172',
  createdById: 'bcbe94e8-e31a-4c1d-bc88-f26c6bfca3ab',
  modifiedById: 'bcbe94e8-e31a-4c1d-bc88-f26c6bfca3ab',
  createdOnUtc: '2025-02-18T20:11:49.4609054'
};

export const paymentRequestsData = {
  paymentRequestsResponse: paymentRequestsResponse,
  paymentRequestResponse: paymentRequestResponse,
};